// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"ff4d446d","475":"5403a3b7","787":"d16d0675","861":"38d3680c","975":"82a1d3de"}[chunkId] + ".chunk.js";
};